const pages = ["Portfolio", "About"];

export default pages;



// WEBPACK FOOTER //
// ./src/data/pages.js